<div class="modal-header d-flex align-items-center justify-content-between">
    <h5 class="modal-title pl-2" id="modal-basic-title">Confirm Terminate Product</h5>
  </div>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-12" id="confirmationMessage">
          <p>
            Please provide the reason to terminate this product. This action will transition the product's status to <strong>Terminated</strong> and cannot be reversed.
          </p>

          <app-dc-textarea 
            [formControl]="terminationReason"
            [countCharacters]="true"
            [minCharacters]="4">
          </app-dc-textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-around align-items-center">
    <button
      type="button"
      class="btn btn-secondary btn-sm"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      (click)="onTerminate()"
      [disabled]="!terminationReason.valid"
    >
      Confirm
    </button>
  </div>